// The key links that can be a tile in the link tiles element (the tiles on the Sales and Admin Space home pages). `id` is what a layout saves, `art` is the illustration
// (components/HubTileArt.jsx) and `accent` is the tile's own colour. The server accepts exactly these ids (backend/helpers/space_layouts.py).
// Up to MAX_LINK_SLOTS tiles SHOW at once, but the list can hold every link: each slot has a "showing" switch (the eye in the Spaces Builder), and a slot that is not showing
// stays in the list so it can be turned on again.
export const MAX_LINK_SLOTS = 10;

export const LINK_TILE_CATALOGUE = [
  { id: 'transport', label: 'Transport', art: 'transport', accent: '#0ea5e9' },
  { id: 'goods-in', label: 'Goods In', art: 'goods-in', accent: '#0d9488' },
  { id: 'customers', label: 'Customers', art: 'crm', accent: '#2563eb' },
  { id: 'projects', label: 'Projects', art: 'm45', accent: '#7a2182' },
  { id: 'quotes', label: 'Quotes', art: 'quotes', accent: '#ee7203' },
  { id: 'proforma', label: 'Pro Forma', art: 'proforma', accent: '#e11d48' },
  { id: 'stock-transfers', label: 'Stock Transfers', art: 'stock-transfer', accent: '#16a34a' },
  { id: 'stock-requests', label: 'Stock Requests', art: 'stock-requests', accent: '#84cc16' },
  { id: 'po-expenses', label: 'P.O. Expenses', art: 'po-expenses', accent: '#c026d3' },
  { id: 'staffology', label: 'Staffology', art: 'staffology', accent: '#cb52e1' },
  { id: 'pi-counts', label: 'PI Counts', art: 'pi-counts', accent: '#06b6d4' },
];

// Links that are in the list but not showing until someone turns them on (a new page starts like this).
export const HIDDEN_BY_DEFAULT = ['pi-counts'];

export const tileById = (id) => LINK_TILE_CATALOGUE.find((tile) => tile.id === id) || null;

// The slots that are showing on the page.
export const shownSlots = (slots) => (Array.isArray(slots) ? slots : []).filter((slot) => !slot.hidden);

// A new page: the ten usual links showing, in the order of the Sales and Admin Space home pages, and the others in the list, not showing.
export const defaultSlots = () => [
  ...LINK_TILE_CATALOGUE.filter((tile) => !HIDDEN_BY_DEFAULT.includes(tile.id)).map((tile) => ({ key: tile.id })),
  ...LINK_TILE_CATALOGUE.filter((tile) => HIDDEN_BY_DEFAULT.includes(tile.id)).map((tile) => ({ key: tile.id, hidden: true })),
];
